export class Note {
  constructor(
    public id: number,
    public name: string,
  ) {}
}
